import { GetExtranetFaqCategoryQueryDto } from '@pharmac-extranet/extranet-api'
import { api } from '../../services/HttpService'

export const faqQueryKeyFactory = {
  categories: (...params: any[]) => ['__getFaqCategories', params],
}

export const getFaqCategoriesQuery = (dto?: GetExtranetFaqCategoryQueryDto) => {
  return {
    queryKey: faqQueryKeyFactory.categories(dto),
    queryFn: async () => await api.faqs.getCategories(dto),
  }
}
